<template>
  <div class="password-requirement-instruction-style">
    <p>{{$t('password_requirements_label')}}</p>
    <ul>
      <li>{{$t('password_requirements')}}</li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'PasswordRequirementsCardComponent',
  components: {},
  data() {
    return {

    }
  },
}
</script>

<style lang="scss">
@import "../../../sass/variables";

.password-requirement-instruction-style {
  p {
    font-size: 0.75rem;
    color: $red;
    padding-left: 1rem;
    margin-bottom: 0.5rem;
  }
  //width: 50%;
  ul {
    li {
      list-style-type: disc;
      color: $red;
      font-size: 0.75rem;
      font-weight: 400;
    }
  }
  padding-top: 1rem;
  padding-bottom: 0.5rem;
  outline: none;
  border: 1px solid $red;
  border-radius: 8px;
}
</style>